const PLUMBING = '/images/services/plumbing';

export const PLUMBING_SERVICE_IMAGES: Record<string, string> = {
  'leak-repair': `${PLUMBING}/leak-repair.webp`,
  'drain-cleaning': `${PLUMBING}/drain-cleaning.webp`,
  'faucet-repair': `${PLUMBING}/faucet-repair.webp`,
  'toilet-repair': `${PLUMBING}/toilet-repair.webp`,
  'water-heater-service': `${PLUMBING}/water-heater-service.webp`,
  'emergency-plumbing': `${PLUMBING}/emergency-plumbing.webp`,
};

export const PLUMBING_SERVICE_CARD_SUBTITLES: Record<string, string> = {
  'leak-repair': 'Pipe, fixture, and under-sink leaks',
  'drain-cleaning': 'Slow drains, clogs, and backups',
  'faucet-repair': 'Drips, low pressure, and replacements',
  'toilet-repair': 'Running toilet, clogs, and leaks',
  'water-heater-service': 'No hot water, leaks, and tune-ups',
  'emergency-plumbing': 'Burst pipes, major leaks, and flooding',
};
